import { https , httpsFile } from './http.js';

const uri = 'temporary-po-detail';

export function show(id,page,current_page,company,storage_location){
    return https().get(`${uri}/${id}?page=${page}&currentpage=${current_page}&company=${company}&storage_location=${storage_location}`) ;
}

export function update(id,data){
    return https().post(`${uri}/${id}`,data) ;
}

export function store(data){
    return https().post(`${uri}`,data);
}

export function checkPr(material_id,company_id){
    return httpsFile().get(`check-pr/${material_id}?company_id=${company_id}`);
}

export function showPRtoCWH(page,search_to_prw_cwh,show_all = false){
    return httpsFile().get(`showPRtoCWH?page=${page}&search=${search_to_prw_cwh}&show_all=${show_all}`);
}

export function cancelPRtoCWH(id){
    return httpsFile().get(`cancelPRtoCWH?id=${id}`);
}

export function destroy(id,data){
    return https().post(`${uri}/${id}`,data);
}

export function forPrint(id,status,post_status){
    return https().get(`${uri}/${id}/edit?status=${status}&post_status=${post_status}`);
}